<div class="d-flex flex-wrap gap-4">
  <app-mdb-button [text]="'API_INTERFACES.NEW'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewApiInterfaceModal()"></app-mdb-button>
</div>

<app-api-interfaces-table></app-api-interfaces-table>
